// src/graphql/queries.ts

import { gql } from "@apollo/client";

export const GET_COMPANIES = gql`
  query GetCompanies {
    companies {
      id
      name
      users {
        id
        name
      }
    }
  }
`;

export const GET_PURCHASE_HISTORY = gql`
  query GetPurchaseHistory($dateRange: DateRangeInput) {
    purchaseHistory(dateRange: $dateRange) {
      id
      createdAt
      totalPrice
      lineItems {
        title
        quantity
        price
      }
      customer {
        firstName
        lastName
        email
      }
    }
  }
`;

export const GET_OUTGOING_ORDERS = gql`
  query GetOutgoingOrders($dateRange: DateRangeInput) {
    outgoingSales(dateRange: $dateRange) {
      id
      createdAt
      totalPrice
      lineItems {
        title
        quantity
        price
      }
      shippingAddress {
        address1
        address2
        city
        province
        country
        zip
      }
      fulfillmentStatus
    }
  }
`;

export const GET_COMPANY_CONNECTIONS = gql`
  query GetCompanyConnections {
    companyConnections {
      shop_domain
      created_at
      updated_at
    }
  }
`;

export const SHOPIFY_INVENTORY_ITEMS = gql`
  query GetShopifyInventoryItems {
    shopifyInventoryItems {
      id
      title
      body_html
      vendor
      product_type
      created_at
      handle
      updated_at
      published_at
      template_suffix
      published_scope
      tags
      status
      admin_graphql_api_id
      variants {
        id
        productId
        title
        price
        option1
        option2
        option3
        inventoryQuantity
        inventoryItemId
        sku
        images {
          id
          src
          altText
          position
        }
      }
      options {
        id
        name
        position
        values
      }
      images {
        id
        src
        altText
        position
      }
      image {
        id
        src
        altText
        position
      }
    }
  }
`;

export const GET_SHOPIFY_LISTING = gql`
  query getShopifyListing($shop_domain: String!, $id: ID!) {
    getShopifyListing(shop_domain: $shop_domain, id: $id) {
      id
      shopifyProductId
      title
      body_html
      vendor
      product_type
      created_at
      handle
      updated_at
      published_at
      template_suffix
      published_scope
      status
      admin_graphql_api_id
      variants {
        id
        title
        sku
        price
        inventoryQuantity
        inventoryItemId
        productId
        selectedOptions {
          name
          value
        }
        images {
          id
          src
          altText
          position
        }
        option1
        option2
        option3
      }
      options {
        id
        name
        position
        values
      }
      images {
        id
        src
        altText
        position
      }
      image {
        id
        src
        altText
        position
      }
    }
  }
`;

export const GET_LISTINGS = gql`
  query GetListings {
    listings {
      id
      shopifyProductId
      title
      body_html
      vendor
      product_type
      created_at
      handle
      updated_at
      published_at
      template_suffix
      published_scope
      tags
      status
      admin_graphql_api_id
      variants {
        id
        title
        sku
        price
        inventoryQuantity
        inventoryItemId
        productId
        images {
          id
          src
          altText
          position
        }
        option1
        option2
        option3
      }
      options {
        id
        name
        position
        values
      }
      images {
        id
        src
        altText
        position
      }
      image {
        id
        src
        altText
        position
      }
    }
  }
`;

export const FETCH_CART = gql`
  query FetchCart($cartId: ID!) {
    fetchCart(cartId: $cartId) {
      id
      checkoutUrl
      lines {
        id
        quantity
        merchandise {
          id
          title
          price
          shop_domain
          checkoutUrl
          image {
            src
            altText
          }
          product {
              title
              description
          }
          selectedOptions {
            name
            value
          }
        } 
      }
    }
  }
`;

export const GET_MERGED_CATEGORIES = gql`
  query GetMergedCategories {
    mergedCategories {
      id
      title
    }
  }
`;

export const GET_ACTIVE_LISTINGS = gql`
  query GetActiveListings($brand: String, $size: String, $search: String, $sortOrder: String, $currentPage: Int, $limit: Int, $collectionId: ID) {
    activeListings(brand: $brand, size: $size, search: $search, sortOrder: $sortOrder, currentPage: $currentPage, limit: $limit, collectionId: $collectionId) {
      listings {
        shop_domain
        id
        title
        vendor
        product_type
        status
        variants {
          id
          price
          sku
          inventoryQuantity
          option1
          option2
          option3
        }
        images {
          src
          altText
        }
        options {
          name
          values
        }
      }
      listingsSummary {
        brands
        sizes
      }
      pagination {
        totalItems
        totalPages
        currentPage
        limit
      }
    }
  }
`;